export enum CapacitySubsectionEnum {
  EXTERNAL_WEBMASTER = "getExternalWebmastersCapacity",
  SUB_WEBMASTER = "getSubWebmastersCapacity"
}

export enum CapacityAnalyseSubsectionEnum {
  WEBMASTER = "getExternalWebmastersCapacityAnalyse",
  EXTERNAL_WEBMASTER = "getExternalWebmastersCapacityAnalyse",
  SUB_WEBMASTER = "getSubWebmastersCapacityAnalyse"
}